import { render } from "./PaginationComponent.vue?vue&type=template&id=58f9c5c6&scoped=true"
import script from "./PaginationComponent.vue?vue&type=script&lang=js"
export * from "./PaginationComponent.vue?vue&type=script&lang=js"

import "./PaginationComponent.vue?vue&type=style&index=0&id=58f9c5c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f9c5c6"]])

export default __exports__